import React from 'react';
import { getNumbers, getTargetNumber } from './Calculations';
import { NumberPuzzle } from './numberSolver';


export class expressionItem {
    itemValue = ' ';
    itemIndex = 0;
    isAvailable = false;
    isUsed = false;

    constructor(itemValue, itemIndex) {
        this.itemValue = itemValue;
        this.itemIndex = itemIndex;
        this.isAvailable = false;
        this.isUsed = false;
        }

    isNumber() {
        return this.itemIndex > 5;
    }
    isRightBracket() {
        return this.itemIndex === 1;
    }
    isLeftBracket() {
        return this.itemIndex === 0;
    }

}

export class arithmeticExpression extends React.Component {
    
    solution = '';
    targetNumber = 0;
    calculatedTotal = 0;
    expressionItems = [];
    formulaHistory = [];
    bracketCount = 0;
    largeCount = 2;
    smallCount = 4;
    calculatedLines = [];
    calculatedErrors = '';

     
    get numberCount() {
        return this.largeCount + this.smallCount;
    }

    constructor(props) {
        super(props);

        this.expressionItems.push(new expressionItem('(', 0));
        this.expressionItems.push(new expressionItem(')', 1));
        this.expressionItems.push(new expressionItem('x', 2));
        this.expressionItems.push(new expressionItem('/', 3));
        this.expressionItems.push(new expressionItem('+', 4));
        this.expressionItems.push(new expressionItem('-', 5));

        this.expressionItems.push(new expressionItem('0', 6));
        this.expressionItems.push(new expressionItem('0', 7));
        this.expressionItems.push(new expressionItem('0', 8));
        this.expressionItems.push(new expressionItem('0', 9));
        this.expressionItems.push(new expressionItem('0', 10));
        this.expressionItems.push(new expressionItem('0', 11));
        this.expressionItems.push(new expressionItem(' ', 12));
        this.expressionItems.push(new expressionItem(' ', 13));
    }

    newGame() {
        let newNumbers = getNumbers(this.largeCount, this.smallCount);
        this.setNumbers(newNumbers);
        this.targetNumber = getTargetNumber();
        this.calculateTotal = 0;
        this.solution = '';
        this.bracketCount = 0;
        this.setCalculatedTotal();
        this.setAvailableItems();
    }

    setGame(newNumbers, target) {
        this.setNumbers(newNumbers);
        this.targetNumber = target;
        this.calculateTotal = 0;
        this.solution = '';
        this.bracketCount = 0;
        this.setCalculatedTotal();
        this.setAvailableItems();
    }

    setLargeSmall(largeCount, smallCount) {
        this.largeCount = largeCount;
        this.smallCount = smallCount;
    }

    changeNumbers() {
        let newNumbers = getNumbers(this.largeCount, this.smallCount);
        this.setNumbers(newNumbers);
        this.calculateTotal = 0;
        this.solution = '';
        this.bracketCount = 0;
        this.setCalculatedTotal();
        this.setAvailableItems();
    }
     
    setCalculatedTotal() {
        let exprs = [];
        let soln = '';
        for (let i = 0; i < this.formulaHistory.length; i++) {
            let index1 = this.formulaHistory[i];
            let value1 = this.expressionItems[index1].itemValue;

            if (soln.length > 0) soln = soln + ' ';
            soln = soln + value1;

            exprs.push(value1);
        }

        this.calculatedTotal = this.calculateFormula(exprs, true);
        this.solution = soln;
    }
    
    setNumbers(numberArray) {
        this.expressionItems.length = 6;
        for (let i = 0; i < numberArray.length; i++) {
            this.expressionItems.push(new expressionItem(numberArray[i], this.expressionItems.length));
        }
        for (let i = this.expressionItems.length; i < 14; i++) {
            this.expressionItems.push(new expressionItem(' ', this.expressionItems.length));
        }
         this.clearFormula();
    }

    setAvailableItems() {
        let isNumbersAvailable = false;
        let isSymbolsAvailable = false;
        let isLeftBracketAvailable = false;
        let isRightBracketAvailable = false;

        if (this.formulaHistory.length === 0) {
            isNumbersAvailable = true;
            isLeftBracketAvailable = true;
        } else {
            let lastItem = this.expressionItems[this.formulaHistory[this.formulaHistory.length-1]];

            if (lastItem.isNumber()) {
                isSymbolsAvailable = true;
                isRightBracketAvailable = (this.bracketCount > 0);
            } else {
                if (lastItem.isRightBracket()) {
                    isSymbolsAvailable = true;
                } else {
                    isNumbersAvailable = true;
                    isLeftBracketAvailable = true;
                }
            }
        }

        this.expressionItems[0].isAvailable = isLeftBracketAvailable;
        this.expressionItems[1].isAvailable = isRightBracketAvailable;

        for (let i = 2; i < 6; i++) {
            this.expressionItems[i].isAvailable = isSymbolsAvailable;
        }
        for (let i = 6; i < this.expressionItems.length; i++) {
            this.expressionItems[i].isAvailable = isNumbersAvailable && !this.expressionItems[i].isUsed && this.expressionItems[i].itemValue !== 0;
        }
    }

    calculateFormula(formulaArray, isBaseLevel) {

        // this is called recursively, track via levelNumber
        if (isBaseLevel) {
            this.calculatedLines = [];
            this.calculatedErrors = '';
            this.solution = '';
            this.calculatedTotal = 0;
         }

        let isError = false;
        let levelResult = 0;
        let newFormulaArray = []; 
        let isBracketsRemoved = false;
      
        // do the brackets ()
        let bracketCount = 0;
        for (let i = 0; i < formulaArray.length; i++) {
            let newElement = formulaArray[i];
    
            if (formulaArray[i] === '(') {
                isBracketsRemoved = true;
                bracketCount++;
                let j = i + 1;
                while (j < formulaArray.length) {
                    if (formulaArray[j] === ')') bracketCount--;
                    if (formulaArray[j] === '(') bracketCount++;
    
                    if (bracketCount === 0) {
                        let tempArray = formulaArray.slice(i+1, j);
                        newElement = this.calculateFormula(tempArray, false);
                        i = j;
                        j = formulaArray.length;
                    }
                    j++;
                }
            }
            newFormulaArray.push(newElement);
        }
   
        // newFormulaArray has brackets removed
        if (isBaseLevel) {
            if (isBracketsRemoved) {
                this.calculatedLines.push('= ' + newFormulaArray.join(' '));
            }
        }

        // do the multiplications and divisions from left to right
        let num = 0;
        while (num < newFormulaArray.length - 2) {
            if (newFormulaArray[num + 1] === "x") {
                newFormulaArray[num + 2] = parseInt(newFormulaArray[num]) * parseInt(newFormulaArray[num + 2]);
                newFormulaArray.splice(num, 2);
                num -= 1;
                if (isBaseLevel) {
                    this.calculatedLines.push('= ' + newFormulaArray.join(' '));
                }
            } 
            if (newFormulaArray[num + 1] === "/") {
                let divisor = parseInt(newFormulaArray[num + 2]);
                let dividend = parseInt(newFormulaArray[num]);
                let quotient = dividend / divisor;
                let remainder = dividend % divisor;

                if (remainder !== 0) {
                    isError = true;
                    this.calculatedLines.push('Error: ' + newFormulaArray.slice(num, num + 3).join(' ') + ' = ' + quotient.toFixed(2) + ', division must result in whole number');
                }
                newFormulaArray[num + 2] = parseInt(quotient);
                newFormulaArray.splice(num, 2);
                num -= 1;

                if (isBaseLevel && isError === false) {
                    this.calculatedLines.push('= ' + newFormulaArray.join(' '));
                }
            }

            num += 1;
            if (isError) num = newFormulaArray.length;
       }
    
        // do the additions and subtractions from left to right
        if (isError === false) {
            let isCalculation = false;
            num = 0;
            while (num < newFormulaArray.length - 2) {
                if (newFormulaArray[num + 1] === "+") {
                    newFormulaArray[num + 2] = parseInt(newFormulaArray[num]) + parseInt(newFormulaArray[num + 2]);
                    newFormulaArray.splice(num, 2);
                    num -= 1;
                    if (isBaseLevel) {
                        isCalculation = true;
                    }
                }
                if (newFormulaArray[num + 1] === "-") {
                    newFormulaArray[num + 2] = parseInt(newFormulaArray[num]) - parseInt(newFormulaArray[num + 2]);
                    newFormulaArray.splice(num, 2);
                    num -= 1;
                    if (isBaseLevel) {
                        isCalculation = true;
                    }
                }
                num += 1;
            }

            if (isCalculation)
                this.calculatedLines.push('= ' + newFormulaArray.join(' '));

            this.calculatedLines.forEach(element => {
                if (isNaN(element)) element = '...';
            });
    
            if (newFormulaArray.length > 0) {
                if (isNaN(newFormulaArray[0])) {
                    levelResult = '...';
                } else {
                    levelResult = parseInt(newFormulaArray[0]);
                }
            }
        }
        return levelResult;
    }
    

    addItemToFormula(parmIndex) {

        if (this.expressionItems[parmIndex].itemValue === '(') {
            this.bracketCount++;
        }
        else if (this.expressionItems[parmIndex].itemValue === ')') {
            this.bracketCount--;
        }
        else if (this.expressionItems[parmIndex].isNumber()) {
            this.expressionItems[parmIndex].isUsed = true;
        }
     
        this.formulaHistory.push(parmIndex);
        this.setCalculatedTotal();
        this.setAvailableItems();
    }

    removeItemFromFormula() {
        if (this.formulaHistory.length > 0) {

            let itemIndex = this.formulaHistory[this.formulaHistory.length-1];
            if (this.expressionItems[itemIndex].itemValue === '(') {
                this.bracketCount--;
            }
            else if (this.expressionItems[itemIndex].itemValue === ')') {
                this.bracketCount++;
            }
            else if (this.expressionItems[itemIndex].isNumber()) {
                this.expressionItems[itemIndex].isUsed = false;
            }
            
            this.formulaHistory.pop();
            this.setCalculatedTotal();
            this.setAvailableItems();
        }
    }

    getOperator(parmSymbol) {
        switch(parmSymbol) {
            case '(':
                return this.expressionItems[0];
            case ')':
                return this.expressionItems[1];
            case 'x':
                return this.expressionItems[2];
            case '/':
                return this.expressionItems[3];
            case '+':
                return this.expressionItems[4];
            case '-':
                return this.expressionItems[5];
            default:
                break;
        }
        return new expressionItem('', -1);
    }

    getNumber(parmIndex) {
        if (parmIndex >= 0) {
            parmIndex = parmIndex + 6; 
            if (parmIndex < this.expressionItems.length) {
                return this.expressionItems[parmIndex];
            }
        }

        return new expressionItem(-1,0);
    }

    clearFormula() {
        this.formulaHistory.length = 0;
        this.bracketCount = 0;
        for (let i = 6; i < this.expressionItems.length; i++) {
            this.expressionItems[i].isUsed = false;
        }
        this.setCalculatedTotal();
        this.setAvailableItems();
    }

    solvePuzzle() {

        /** prepare parameters for the numberSolver */
        let bigOnes = [];
        for (let i = 6; i < (6 + this.largeCount); i++) {
            bigOnes.push(this.expressionItems[i].itemValue);
        }
        let littleOnes = [];
        for (let i = (6 + this.largeCount); i < (6 + this.largeCount + this.smallCount); i++) {
            littleOnes.push(this.expressionItems[i].itemValue);
        }

        /** get solution */
        let puzzleSolver = new NumberPuzzle(this.targetNumber, this.largeCount, this.largeCount + this.smallCount, bigOnes, littleOnes);
        let solns = puzzleSolver.solve();

        /** set temp formula from solution, join numerics into numbers */
        let solnArray = [];
        let tempArray = solns.best.toString().split('');
        let expr1 = '';
        for (let i in tempArray) {
            let x = tempArray[i];
            if ('0123456789'.includes(x)) {
                expr1 = expr1.concat(x);
            }
            else if ('()x/+- '.includes(x)) {
                if (expr1.length > 0) {
                    solnArray.push(expr1);
                    expr1 = '';
                }
                if (x !== ' ') {
                    solnArray.push(x);
                }
            }
        }
        if (expr1.length > 0) {
            solnArray.push(expr1);
        }

        /** clear formula and clear usage for numbers */
        this.formulaHistory.length = 0;
        for (let i = 6; i < this.expressionItems.length; i++) {
            this.expressionItems[i].isUsed = false;
        }
        
        /** move solution to formula history, add x for implied multiplication */
        let leftBracketIndex = this.getOperator('(').itemIndex;
        let rightBracketIndex = this.getOperator(')').itemIndex;
        let multiplyIndex = this.getOperator('x').itemIndex;

        let prevIndex = -1;
        for (let s = 0; s < solnArray.length; s++) {
            let thisIndex = -1
            let e = 0;
            while (e < this.expressionItems.length) {
                if (solnArray[s] == this.expressionItems[e].itemValue && this.expressionItems[e].isUsed === false) {
                    thisIndex = e;
                    e = this.expressionItems.length;
                }
                e++;
            }
        

            if (thisIndex >= 0) {

                /** add x for implied multiplication */
                if (prevIndex > 5 && thisIndex > 5) {
                    this.formulaHistory.push(multiplyIndex);
                }
                else if (prevIndex === rightBracketIndex && thisIndex === leftBracketIndex) {
                    this.formulaHistory.push(multiplyIndex);
                }
                else if (prevIndex > 5 && thisIndex === leftBracketIndex) {
                    this.formulaHistory.push(multiplyIndex);
                }
                else if (prevIndex === rightBracketIndex && thisIndex > 5) {
                    this.formulaHistory.push(multiplyIndex);
                }

                this.formulaHistory.push(thisIndex);
                if (thisIndex > 5) {
                    this.expressionItems[thisIndex].isUsed = true;
                }
            }
            prevIndex = thisIndex;
        }

        this.setCalculatedTotal();
        this.setAvailableItems();
   
    }

}



